import { NgModule } from '@angular/core';
import { WhiteSpacePipe } from './white-space.pipe';

@NgModule({
  declarations: [WhiteSpacePipe],
  exports: [WhiteSpacePipe],
})
export class WhiteSpaceModule {}
